import dark_colorblind from '../../src/primer/dark-colorblind'
import dark_dimmed from '../../src/primer/dark-dimmed'
import dark_high_contrast from '../../src/primer/dark-high-contrast'
import dark_tritanopia from '../../src/primer/dark-tritanopia'
import dark from '../../src/primer/dark'
import light_colorblind from '../../src/primer/light-colorblind'
import light_high_contrast from '../../src/primer/light-high-contrast'
import light_tritanopia from '../../src/primer/light-tritanopia'
import light from '../../src/primer/light'

const colors = {
  dark_colorblind,
  dark_dimmed,
  dark_high_contrast,
  dark_tritanopia,
  dark,
  light_colorblind,
  light_high_contrast,
  light_tritanopia,
  light,
}

export default colors
